export default __webpack_public_path__ + "static/media/office1-after2-1024w.40f3b383.avif";